import React from 'react'

export default function LayoutsEREP(props) {
  return (
    <section><a className="anchor" id="erep"></a>
      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
            <a href="samples/erep.html"><img src="images/erep.png" alt="Screenshot of the extract-text-webpack-plugin snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12  grid__col-lg-6">
            <h2>EREP</h2>
            Example of using -
            <ul>
              <li><a href={props.staticVersion === true ? '#core/navigation' : 'Core#navigation'}>Navigation</a></li>
              <li><a href={props.staticVersion === true ? '#core/tables' : 'Core#tables'}>Tables</a></li>
              <li><a href={props.staticVersion === true ? '#core/grid' : 'Core#grid'}>Grid</a></li>
              <li><a href={props.staticVersion === true ? '#core/buttons' : 'Core#buttons'}>Buttons</a></li>
              <li><a href={props.staticVersion === true ? '#core/forms' : 'Core#forms'}>Forms</a></li>
              <li><a href={props.staticVersion === true ? '#core/pagination' : 'Core#pagination'}>Pagination</a></li>
            </ul>
            <p><a className="btn" href="samples/erep.html">View live preview</a>&nbsp;<a className="btn" href="samples/erep.html" download>Download</a></p>
          </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/LayoutsEREP.js